<template>
    <div>
        <div v-if="$route.meta.breadcrumb || $route.meta.pageTitle" class="router-header flex flex-wrap items-center mb-2">
            <div
                class="content-area__heading"
                :class="{'pr-4 border-0 md:border-r border-solid border-grey-light' : $route.meta.breadcrumb}">
                  <h2 class="mt-2">{{ $t(routeTitle) }}</h2>
            </div>
                
            <vx-breadcrumb class="ml-4 md:block hidden" v-if="$route.meta.breadcrumb" />
                
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            routeTitle        : this.$route.meta.pageTitle
        };
    },

    watch: {
        '$route' () {
            this.routeTitle = this.$route.meta.pageTitle
        },
    }
};
</script>